import React, { useEffect } from "react";
import { Form } from "antd";

import SectionPart from "../../../../components/SectionPart";
import { formSectionsController, vendors } from "../../../../formSectionsController";
import { ConfigurableRow, ROW_OPTIONS } from "../../../../ConfigurableRow";
import { patientFields } from "../fieldNames";
import { UnifiedCaregiverSection } from "../../../../components/form/UnifiedCaregiverSection";

export default function GenentechFreeDrugPatient() {
  const patientFormComponents = formSectionsController().getSectionFieldsByVendor(vendors.GENENTECH_PAP)().patient;

  const form = Form.useFormInstance();
  const patientGender = Form.useWatch(patientFields.gender, form);

  useEffect(() => {
    form.validateFields();
  }, [form]);

  return (
    <SectionPart
      sectionId="patient"
      headerTranslationKey="application_form_editor.genentech.free_drug.patient.labels.header"
    >
      <>{patientFormComponents.id()}</>
      <ConfigurableRow config={ROW_OPTIONS.EQUAL}>
        {[
          patientFormComponents.firstName({ required: true }),
          patientFormComponents.middleName({ required: false }),
          patientFormComponents.lastName({ required: true }),
          patientFormComponents.gender({
            required: true,
            showError: !patientGender
          })
        ]}
      </ConfigurableRow>
      <ConfigurableRow config={ROW_OPTIONS.PROPORTION_1_3}>
        {[patientFormComponents.dob({ required: true }), patientFormComponents.address({ required: true })]}
      </ConfigurableRow>
      <ConfigurableRow config={ROW_OPTIONS.PROPORTION_1_2_2}>
        {[
          patientFormComponents.city({ required: true }),
          patientFormComponents.state({ required: true }),
          patientFormComponents.zip_code({ required: true })
        ]}
      </ConfigurableRow>
      <ConfigurableRow config={ROW_OPTIONS.EQUAL}>
        {[
          patientFormComponents.phone_number({ required: true }),
          patientFormComponents.additional_phone_number({ required: false }),
          patientFormComponents.preferred_language({ required: true }),
          patientFormComponents.email({ required: false })
        ]}
      </ConfigurableRow>
      <ConfigurableRow config={ROW_OPTIONS.PROPORTION_1_BLANK}>
        {[patientFormComponents.alternative_contact({ required: true })]}
      </ConfigurableRow>
      <UnifiedCaregiverSection alternativeContactField={patientFields.alternativeContact} />
    </SectionPart>
  );
}
